module.exports = __webpack_public_path__ + "img/FSBS_big sword v3.40863991.png";